import React, { useState } from 'react';
import { Row, Button, Col } from 'reactstrap';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import DataReactTableModalQuickServCons from './DataReactTableModalQuickServCons';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const ConsulationModal = ({ data = [], openModal, setOpenModal, addDiagnostic, disabledForm = false }) => {

    const [servicesToSend, setServicesToSend] = useState([])

    const handleChange = (event) => {
        let procedure = JSON.parse(event.target.value)
        console.log({ procedure }, event.target.checked)
        if (event.target.checked) {
            setServicesToSend(prevState => [...prevState, procedure])
        } else {
            let currentServices = [...servicesToSend];
            let newServices = currentServices.filter(serv => serv.cupscod !== procedure.cupscod);
            setServicesToSend(newServices);
        }
    }

    const reactTableDataModalQuickServicesCons = {
        tableHeaderData: [{
            Header: '',
            accessor: 'id_ser_acc_rap',
            width: 10,
            maxWidth: 20,
            minWidth: 10,
            minHeight: 8,
            padding: 0,
            Cell: row => (
                <FormControlLabel
                    style={{ width: 10 }}
                    control={
                        <MedicalCheckbox
                            disabled={disabledForm}
                            onChange={handleChange}
                        />
                    }
                    value={JSON.stringify(row.row.original)}
                //label={row.abreviatura}
                />
            )
        },
        {
            Header: 'CUPS',
            accessor: 'cupscod',
            minWidth: 20,
            minHeight: 8,
            padding: 0,
            Cell: row => (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ marginTop: 10 }}><strong>{row.value}</strong></div>
                </div>
            )
        },
        {
            Header: 'NOMBRE',
            accessor: 'cupsnom',
            minHeight: 8,
            padding: 0,
            Cell: row => (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ marginTop: 10 }}>{row.row.original.cupsnom}</div>
                </div>
            )
        },
        ],
        tableRowsData: data
    };

    const LoadInfo = () => {
        return (<DataReactTableModalQuickServCons
            reactTableData={reactTableDataModalQuickServicesCons}
        />)
    }

    return (
        <Modal
            open={openModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}>

            <div className="paperAppointment-flex" style={{ width: '70%', maxHeight: '80%', margin: 10, overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div className="card__title">
                    <h4 className="bold-text">Consultas Especializadas  </h4>
                </div>
                <Row className='modal-medical-orders'>
                    {data.map((procedures, index) => {
                        return <Col md={4} sm={12} key={index} className='element'>
                            <FormControlLabel
                                control={
                                    <MedicalCheckbox
                                        onChange={handleChange}
                                        disabled={disabledForm}
                                    />
                                }
                                value={JSON.stringify(procedures)}
                                label={procedures.abreviatura}
                            />
                        </Col>
                    })}
                </Row>

                {/* <Row>
                    {!!data.length ?
                    <div className='wrapper-table'>
                        <LoadInfo />
                    </div>
                        : null
                    }
                </Row> */}

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <Button
                        style={{ marginTop: 10, marginLeft: 10 }}
                        size="sm"
                        onClick={() => {
                            setOpenModal();
                        }}
                    >
                        Cerrar
                    </Button>
                    <Button
                        style={{ marginTop: 10 }}
                        disabled={disabledForm}
                        size="sm"
                        color="primary"
                        onClick={() => {
                            setOpenModal();
                            addDiagnostic(servicesToSend);
                        }}
                    >
                        Aceptar
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default ConsulationModal;